var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-container",attrs:{"id":"app"}},[_c('div',{staticClass:"navbar"},[_c('Navbar')],1),_c('div',{staticClass:"main"},[(_vm.status == 'ok')?_c('div',[_c('router-view')],1):_c('div',{staticClass:"app-load"},[_c('div',[_vm._v("Preparing your tournaments!")]),_c('Loader',{attrs:{"status":_vm.status}})],1)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fa5ba8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 